import { FileDownloadDropdown } from '@/features/invoices/components/Details/Components/Left/FileDownloadDropdown';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './DownloadButton.module.scss';
const cx = classNames.bind(styles);

export type Props = {
  onDownloadClick: () => void;
  isPeppolGateway?: boolean;
  fileName?: string;
  invoiceId?: string;
};

export const DownloadButton: FC<Props> = memo(
  ({ onDownloadClick, isPeppolGateway, fileName, invoiceId }) => {
    const { t } = useTranslation();
    const flagEdocMetadata = useGetFlags('E_DOC_METADATA');

    return (
      <>
        {isPeppolGateway ? (
          <FileDownloadDropdown
            onDownloadPDF={onDownloadClick}
            fileName={fileName}
            invoiceId={invoiceId}
          />
        ) : (
          <ButtonV2
            onClick={onDownloadClick}
            containerClassName={cx({
              [styles['black-button']]: flagEdocMetadata,
            })}
            isSecondary={!flagEdocMetadata}
            isTertiary={!flagEdocMetadata}
          >
            {t('ダウンロード')}
          </ButtonV2>
        )}
      </>
    );
  }
);
DownloadButton.displayName = 'DownloadButton';
